import {
	CommandPayload,
	Guid,
	HttpStatus,
	IRecord,
	IRestRequest,
	MicroTaskConfig,
	MicrotaskType,
} from 'ihub/common';

export default function InitTaskSampleData(microTaskConfig: MicroTaskConfig) {
	const result: IRecord = { id: Guid(), processingData: {} };
	if (microTaskConfig.taskType === MicrotaskType.RestApiReceiver) {
		const restRequest: IRestRequest = {
			httpURL: '',
			httpMethod: 1,
			headers: {},
			query: {},
			body: {},
		};
		result.processingData = restRequest;
	}
	if (typeof microTaskConfig.sampleData === 'string') {
		throw new Error('The sample data should not be a string at this point');
	}
	if (microTaskConfig.sampleData) {
		return { ...microTaskConfig.sampleData };
	} else {
		microTaskConfig.sampleData = new CommandPayload({
			isSync: false,
			records: [result],
		});
	}

	if (typeof microTaskConfig.resultData === 'string') {
		throw new Error('The sample data should not be a string at this point');
	}
	if (microTaskConfig.resultData) {
		return { ...microTaskConfig.resultData.body };
	} else {
		microTaskConfig.resultData = { status: HttpStatus.OK, body: new CommandPayload() };
	}
}
